import formsHOC from 'app/formComponents/formikHOC';
import { ValidationProcessor, ErrorsPopulator } from '@tacitknowledge/validator';

import { validateBy } from 'app/formComponents/formComponentsUtils';
import { emptyObjectProperties } from 'app/utils/helpers';
import WaitingListComponent from './waitingListPageComponent';

const NULL = 'null';
const { componentData } = window.waitingList;
const { interestId, emailSubscription, sites } = componentData;

const { validation } = window.waitingList;
const validationProcessor = new ValidationProcessor(validation);
const errorsPopulator = new ErrorsPopulator(validationProcessor);

const validate = validateBy(validationProcessor, errorsPopulator, validation);

const initialValues = {
  ...emptyObjectProperties(validation.rules),
  emailSubscription,
  interestId,
  site: sites && sites.length > 0 ? '' : NULL,
};
const mapPropsToValues = () => initialValues;

export default formsHOC({
  validate,
  validations: validation,
  initialValues,
  mapPropsToValues,
  formName: 'waitingListPage',
})(WaitingListComponent);
